// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars20: FC<Webinars20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M17.5 17V4.5h-15V12H1V4.5c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h15c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06v11c0 .403-.147.753-.44 1.052A1.433 1.433 0 0 1 17.5 17ZM7 12a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 9c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 6c.833 0 1.542.292 2.125.875S10 8.167 10 9s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 7 12Zm.004-1.5c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 0 0 6.996 7.5c-.414 0-.767.147-1.059.442A1.456 1.456 0 0 0 5.5 9.004c0 .414.147.767.442 1.059.294.291.649.437 1.062.437ZM1 18v-1.917c0-.36.087-.687.26-.979.174-.291.414-.535.72-.729a9.111 9.111 0 0 1 2.41-1.031A10.06 10.06 0 0 1 7 13c.889 0 1.753.115 2.594.344.84.229 1.65.573 2.427 1.031.305.18.545.42.719.721.173.3.26.63.26.987V18H1Zm1.5-1.5h9V16a.329.329 0 0 0-.063-.196.421.421 0 0 0-.166-.137 9.429 9.429 0 0 0-2.073-.865 8.183 8.183 0 0 0-4.406 0c-.723.202-1.41.49-2.063.865a.569.569 0 0 0-.167.146A.306.306 0 0 0 2.5 16v.5Z" />
        </svg>
    );
};

export default Webinars20;
